/* eslint-disable max-len */
/* eslint-disable react/button-has-type */
/* eslint-disable no-unused-vars */
// react
import React, { useEffect, useReducer, useState } from 'react';

// third-party
import PropTypes from 'prop-types';
import queryString from 'query-string';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet-async';

// application
import { Button } from 'react-bootstrap';
import BlockLoader from '../blocks/BlockLoader';
import CategorySidebar from './CategorySidebar';
import CategorySidebarItem from './CategorySidebarItem';
import PageHeader from '../shared/PageHeader';
import ProductsView from './ProductsView';
import shopApi from '../../api/shop';
import WidgetFilters from '../widgets/WidgetFilters';
import WidgetProducts from '../widgets/WidgetProducts';
import { sidebarClose } from '../../store/sidebar';

// data stubs
import theme from '../../data/theme';
import { url, getCategoryParents } from '../../services/utils';

function parseQueryOptions(location) {
    const query = queryString.parse(location);
    const optionValues = {};

    if (typeof query.page === 'string') {
        optionValues.page = parseFloat(query.page);
    }
    if (typeof query.limit === 'string') {
        optionValues.limit = parseFloat(query.limit);
    }
    if (typeof query.sort === 'string') {
        optionValues.sort = query.sort;
    }

    return optionValues;
}

function parseQueryFilters(location) {
    const query = queryString.parse(location);
    const filterValues = {};

    Object.keys(query).forEach((param) => {
        const mr = param.match(/^filter_([-_A-Za-z0-9]+)$/);

        if (!mr) {
            return;
        }

        const filterSlug = mr[1];

        filterValues[filterSlug] = query[param];
    });

    return filterValues;
}

function parseQuery(location) {
    return [
        parseQueryOptions(location),
        parseQueryFilters(location),
    ];
}

function buildQuery(options, filters) {
    const params = {};

    if (options.page !== 1) {
        params.page = options.page;
    }

    if (options.limit !== 12) {
        params.limit = options.limit;
    }

    if (options.sort !== 'default') {
        params.sort = options.sort;
    }

    Object.keys(filters).filter((x) => x !== 'category' && !!filters[x]).forEach((filterSlug) => {
        params[`filter_${filterSlug}`] = filters[filterSlug];
    });

    return queryString.stringify(params, { encode: false });
}

const initialState = {
    init: false,
    /**
     * Indicates that the category is loading.
     */
    categoryIsLoading: true,
    /**
     * Category object.
     */
    category: null,
    /**
     * Indicates that the products list is loading.
     */
    productsListIsLoading: true,
    /**
     * Products list.
     */
    productsList: null,
    /**
     * Products list options.
     *
     * options.page:  number - Current page.
     * options.limit: number - Items per page.
     * options.sort:  string - Sort algorithm.
     */
    options: {},
    /**
     * Products list filters.
     *
     * filters[FILTER_SLUG]: string - filter value.
     */
    filters: {},
};

function reducer(state, action) {
    switch (action.type) {
    case 'FETCH_CATEGORY_SUCCESS':
        return {
            ...state,
            init: true,
            categoryIsLoading: false,
            category: action.category,
        };
    case 'FETCH_PRODUCTS_LIST':
        return { ...state, productsListIsLoading: true };
    case 'FETCH_PRODUCTS_LIST_SUCCESS':
        return { ...state, productsListIsLoading: false, productsList: action.productsList };
    case 'SET_OPTION_VALUE':
        return {
            ...state,
            options: { ...state.options, page: 1, [action.option]: action.value },
        };
    case 'SET_FILTER_VALUE':
        return {
            ...state,
            options: { ...state.options, page: 1 },
            filters: { ...state.filters, [action.filter]: action.value },
        };
    case 'RESET_FILTERS':
        return { ...state, options: { ...state.options, page: 1 }, filters: {} };
    case 'RESET':
        return state.init ? initialState : state;
    default:
        throw new Error();
    }
}

function init(state) {
    const [options, filters] = parseQuery(window.location.search);
// console.log('filters', filters);
    return { ...state, options, filters };
}

function ShopCategoryChild(props) {
    const {
        categorySlug,
        columns,
        viewMode,
        sidebarPosition,
    } = props;

    const { match: { params } } = props;
    const { brandName, modelName } = params;
    const offcanvas = columns === 3 ? 'mobile' : 'always';
    const [state, dispatch] = useReducer(reducer, initialState, init);
    const [latestProducts, setLatestProducts] = useState([]);
    const [category, setCategory] = useState(null);

    let childView = '';

    // Replace current url.
    useEffect(() => {
        const query = buildQuery(state.options, state.filters);
        const location = `${window.location.pathname}${query ? '?' : ''}${query}`;

        window.history.replaceState(null, '', location);
    }, [state.options, state.filters]);

    // Load category.
    useEffect(() => {
        let request;
        let canceled = false;

        dispatch({ type: 'RESET', categorySlug });

        if (categorySlug) {
            request = shopApi.getCategoryBySlugLive(categorySlug);
        } else {
            request = Promise.resolve(null);
        }

        request.then((category) => {
            if (canceled) {
                return;
            }

            const category1 = category.find((x) => x.alias === categorySlug);
            setCategory(category1);
            dispatch({ type: 'FETCH_CATEGORY_SUCCESS', category });
        });

        return () => {
            canceled = true;
        };
    }, [dispatch, categorySlug]);

    // Load products.
    useEffect(() => {
        let canceled = false;

        dispatch({ type: 'FETCH_PRODUCTS_LIST' });

        shopApi.getProductsList(
            state.options,
            { ...state.filters, category: categorySlug },
        ).then((productsList) => {
            if (canceled) {
                return;
            }

            dispatch({ type: 'FETCH_PRODUCTS_LIST_SUCCESS', productsList });
        });

        return () => {
            canceled = true;
        };
    }, [dispatch, categorySlug, state.options, state.filters]);

    // Load latest products.
    useEffect(() => {
        let canceled = false;

        if (offcanvas === 'always') {
            setLatestProducts([]);
        } else {
            shopApi.getLatestProducts({ limit: 5 }).then((result) => {
                if (canceled) {
                    return;
                }

                setLatestProducts(result);
            });
        }

        return () => {
            canceled = true;
        };
    }, [offcanvas]);

    if (state.categoryIsLoading || (state.productsListIsLoading && !state.productsList)) {
        return <BlockLoader />;
    }
    // console.log(params, modelName);
    const breadcrumb = [
        { title: 'Home', url: url.home() },
    ];
    if (brandName) {
        breadcrumb.push({ title: 'Brands', url: '/brands' });
        breadcrumb.push({ title: brandName.toUpperCase(), url: url.brand(brandName) });
        breadcrumb.push({ title: modelName.toUpperCase(), url: url.model(brandName, modelName) });
    }
    if (categorySlug) {
        breadcrumb.push({ title: categorySlug.toUpperCase(), url: `${url.model(brandName, modelName)}/${categorySlug}` });
    }
    let pageTitle = 'Shop';
    let content;

    if (state.category) {
        getCategoryParents(state.category).forEach((parent) => {
            breadcrumb.push({ title: parent.name, url: url.category(parent) });
        });

        breadcrumb.push({ title: state.category.name, url: url.category(state.category) });

        pageTitle = state.category.name;

    // eslint-disable-next-line no-debugger
    // debugger;
    // console.log('state.productsList', state.productsList);
    // console.log('categorys child', state.category[0].childs);

        childView = (

            <div className="">
                {/* {state.category[0].childs.map((c, i) => (
                    <Button
                        title={c.alias.toUpperCase()}
                        type="button"
                        className=""
                        variant="outline-danger"
                        onClick={() => ''}
                    >
                        { c.alias.toUpperCase().replace(/-/g, ' ') }
                    </Button>
                ))} */}
            </div>
        );
    }

    const productsView = (
        <ProductsView
            isLoading={state.productsListIsLoading}
            productsList={state.productsList}
            options={state.options}
            filters={state.filters}
            dispatch={dispatch}
            layout={viewMode}
            // grid={`grid-${columns}-${columns > 3 ? 'full' : 'sidebar'}`}
            grid="grid-4-full"
            offcanvas={offcanvas}
        />
    );
    if (columns > 3) {
        content = (
            <div className="container">
                {childView}
                <div className="block">{productsView}</div>
            </div>
        );
    } else {
        const sidebar = (
            <div className="shop-layout__sidebar" />
        );

        content = (
            <div className="container">
                {childView}
                <div className="block">{productsView}</div>
            </div>
        );
    }
    // console.log('state.category', state.category, category);
    return (
        <React.Fragment>
            <Helmet>
                <title>{ `${category && category.descriptions[0] ? `${category.descriptions[0].title} used parts - ${theme.name}` : 'Propel Autoparts : Original Used European Auto Parts With Quality'}` }</title>
                <meta title={`${category && category.descriptions[0] ? `${category.descriptions[0].title} used parts - ${theme.name}` : 'Propel Auto Parts - European Used Parts Seller'}`} />
                <meta name="title" content={`${category && category.descriptions[0] ? category.descriptions[0].title : 'Propel Autoparts : Original Used European Auto Parts With Quality'}`} />
                <meta name="keyword" content={`${category && category.descriptions[0] ? category.descriptions[0].keyword : 'Propel Autoparts : Original Used European Auto Parts With Quality'}`} />
                <meta name="description" content={`${category && category.descriptions[0] ? category.descriptions[0].description : 'Propel Autoparts : Original Used European Auto Parts With Quality'}`} />
            </Helmet>

            <PageHeader header={pageTitle} breadcrumb={breadcrumb} />

            {content}
        </React.Fragment>
    );
}

ShopCategoryChild.propTypes = {
    /**
     * Category slug.
     */
    categorySlug: PropTypes.string,
    /**
     * number of product columns (default: 3)
     */
    columns: PropTypes.number,
    /**
     * mode of viewing the list of products (default: 'grid')
     * one of ['grid', 'grid-with-features', 'list']
     */
    viewMode: PropTypes.oneOf(['grid', 'grid-with-features', 'list']),
    /**
     * sidebar position (default: 'start')
     * one of ['start', 'end']
     * for LTR scripts "start" is "left" and "end" is "right"
     */
    sidebarPosition: PropTypes.oneOf(['start', 'end']),
};

ShopCategoryChild.defaultProps = {
    columns: 3,
    viewMode: 'grid',
    sidebarPosition: 'start',
};

const mapStateToProps = (state) => ({
    sidebarState: state.sidebar,
    page: state.category,
});

const mapDispatchToProps = () => ({
    sidebarClose,
});

export default connect(mapStateToProps, mapDispatchToProps)(ShopCategoryChild);
